import React, { useEffect } from 'react';
import { node } from 'prop-types';
import { useLocation } from 'react-router-dom';

import { StockPopUpBuySell } from 'Component/__deprecated__/StockActionV2';
import useReducer from '@hooks/useReducer';
import { TYPE_BUY } from 'Component/__deprecated__/StockActionV2/constants';
import useStockFeatureToggle from '@hooks/stock/useStockFeatureToggle';
import { noop } from '@ajaibid/utils';
import StockPopUpProvider from './popup';
import reducers, {
  CLICK_BUY_SELL,
  INITIAL_STATE,
  RESET_STATE,
  SELECT_STOCK,
} from './stockReducers';

export const StockContext = React.createContext();

export const DEFAULT_VALUE = {
  ...INITIAL_STATE,
  handleClickBuySell: noop,
  handleSelectStock: noop,
  handleClosePopUp: noop,
};

const StockProvider = ({ children }) => {
  const location = useLocation();
  const { state, dispatchHelper } = useReducer(reducers, INITIAL_STATE);
  const { featStockRevamp } = useStockFeatureToggle();

  /**
   * @param {String} type TYPE_BUY_STOCK | TYPE_SELL_STOCK | TYPE_AMEND_STOCK | TYPE_EDIT_AUTO
   */
  const handleClickBuySell = (type = TYPE_BUY, code = 'BBCA', price = 0) => {
    dispatchHelper(CLICK_BUY_SELL, { type, code, price });
  };

  /**
   * @param {String} code
   */
  const handleSelectStock = (code = '') => {
    dispatchHelper(SELECT_STOCK, code);
  };

  const handleClosePopUp = () => {
    dispatchHelper(RESET_STATE);
  };

  useEffect(() => {
    // To handle close popup if page change
    handleClosePopUp();
  }, [location]);

  const valueProps = {
    ...state,
    initPrice: state.initPrice,
    selectedCode: state.selectedCode,
    typeOrder: state.typeOrder || TYPE_BUY,
    handleClickBuySell,
    handleSelectStock,
    handleClosePopUp,
  };

  return (
    <StockContext.Provider value={featStockRevamp ? valueProps : DEFAULT_VALUE}>
      {children}
      {!!state.selectedCode && (
        <StockPopUpProvider selectedCode={state.selectedCode}>
          <StockPopUpBuySell {...valueProps} />
        </StockPopUpProvider>
      )}
    </StockContext.Provider>
  );
};

StockProvider.propTypes = {
  children: node.isRequired,
};

export default StockProvider;
